"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffUpdateFrameModel = instanceOfLiffUpdateFrameModel;
exports.LiffUpdateFrameModelFromJSON = LiffUpdateFrameModelFromJSON;
exports.LiffUpdateFrameModelFromJSONTyped = LiffUpdateFrameModelFromJSONTyped;
exports.LiffUpdateFrameModelToJSON = LiffUpdateFrameModelToJSON;
exports.LiffUpdateFrameModelToJSONTyped = LiffUpdateFrameModelToJSONTyped;
/**
 * Check if a given object implements the LiffUpdateFrameModel interface.
 */
function instanceOfLiffUpdateFrameModel(value) {
    return true;
}
function LiffUpdateFrameModelFromJSON(json) {
    return LiffUpdateFrameModelFromJSONTyped(json, false);
}
function LiffUpdateFrameModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'frameNo': json['frameNo'] == null ? undefined : json['frameNo'],
        'status': json['status'] == null ? undefined : json['status'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
    };
}
function LiffUpdateFrameModelToJSON(json) {
    return LiffUpdateFrameModelToJSONTyped(json, false);
}
function LiffUpdateFrameModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orgId': value['orgId'],
        'frameNo': value['frameNo'],
        'status': value['status'],
        'startDate': value['startDate'] == null ? undefined : (value['startDate'].toISOString()),
        'endDate': value['endDate'] == null ? undefined : (value['endDate'].toISOString()),
    };
}
